module.exports = __webpack_public_path__ + "img/bg_simple@2x.c9b47351.png";